<pr-input-abstract
  [control]="control"
  [label]="label"
  [derrors]="derrors"
  [suffix]="suffix"
  class="pr-input-radio"
>
  <mat-slider
    [min]="min"
    [max]="max"
    [step]="step"
  >
    <input
      matSliderThumb
      #input
      [(ngModel)]="value"
      (valueChange)="onSliderChange($event)"
    />
  </mat-slider>
  <input
    matInput
    [(ngModel)]="value"
    (change)="onInputChange({ value: value })"
  />
</pr-input-abstract>
